import axios from 'axios';
import store from 'store/index';
import moment from 'moment';
import calculators from 'services/api/calculators';
import calculatorModals from 'services/api/calculatorModals';
import claims from 'services/api/claims';
import generatedDocuments from 'services/api/generatedDocuments';
import resources from 'services/api/resources';
import miniCalculators from 'services/api/miniCalculators';
import dashboards from 'services/api/dashboards';
import users from 'services/api/users';
import support from 'services/api/support';
import personalInjury from 'services/api/personalInjury';
import exceptions from 'services/api/exceptions';
import contacts from 'services/api/contacts';

const API_VERSION = 'v1';
let token = document.head.querySelector('meta[name="csrf-token"]');

const config = () => {
    const auth = {'Authorization': "Bearer " + store.getters['user/getToken']};
    const csrf = {};
    if (process.env.NODE_ENV==="production") {
        csrf['X-CSRF-TOKEN'] = token.content;
    }
    return {
        headers: {
            ...auth,
            ...csrf
        }
    };
};

const onError = (error) => {
    store.dispatch('http/error', error);
    throw error;
};

const onSuccess = (response, showRunning) => {
    store.dispatch('http/stop', {response, showRunning});
    return response.data;
};

/**
 * API URL Constructor.
 *
 * @param  {String} path
 *
 * @return {String}
 */
const apiUrl = path => `/api/${API_VERSION}/${path}`;

/**
 * Performs an Axios API Call.
 *
 * @param  {String} url
 * @param  {Object} payload
 * @param  {boolean} [showRunning] show the running indicator
 * @return {Promise}
 */
export const makeCall = (url, payload, showRunning = true) => {
    store.dispatch('http/start', {url, showRunning});
    return axios
        .post(url, payload, config())
        .then(onSuccess)
        .catch(onError);
};

/**
 * Default Payload from Params.
 *
 * @param  {} params
 *
 * @return {}
 */
// const defaultPayload = params => params; // This is not being used just yet, couldn't get it working.

/**
 * Make a Request to an Endpoint, defined by the Resource Type, an Action
 * on the Resource and a payload of data.
 *
 * @param  {String} resource
 * @param  {String} action
 * @param  {Object} payload
 * @param  {boolean} [showRunning]
 *
 * @return {Promise}
 */
export const endpoint = (resource, action, payload, showRunning = true) => makeCall(
    apiUrl(`${resource}/${action}`),
    payload,
    showRunning
);

/**
 * Convert from day/month/year to year-month-day.
 *
 * @param {string} date
 *
 * @return {string}
 */
export const dateToServer = date => date ? moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

/**
 * Api Controllers for:
 *     - Calculators
 *     - Calculator Modals
 *     - Claims
 *     - Generated Documents
 */
export default {
    calculators,
    calculatorModals,
    claims,
    generatedDocuments,
    miniCalculators,
    resources,
    dashboards,
    users,
    support,
    personalInjury,
    exceptions,
    contacts
};



// WEBPACK FOOTER //
// ./src/services/Api.js